import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { createDistributorProfileThunk, getDistributorProfileThunk, updateDistributorProfileThunk } from 'store/reducers/user_profiles/profileSlice';
import UserCommonProfile from './UserCommonProfile';

const DistributorProfile = () => {
  const { userProfileId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    console.log(data);
    if (userProfileId) {
      dispatch(updateDistributorProfileThunk({ id: userProfileId, data }));
    } else {
      dispatch(createDistributorProfileThunk(data));
    }
  };
  const status = useSelector((state) => state.profiles.status);
  const currentProfile = useSelector((state) => state.profiles.currentProfile);
  useEffect(() => {
    if (status?.success === "create") {
      navigate("/");
    }
  }, [status?.success]);

  useEffect(() => {
    console.log("U.P", userProfileId);
    if (userProfileId) {
      dispatch(getDistributorProfileThunk(userProfileId));
    }
  }, [userProfileId]);

  return (
    <>
      {userProfileId ? (
        currentProfile && (
          <UserCommonProfile
            userProfile={currentProfile}
            onSubmit={onSubmit}
            loading={
              status?.loading === "create" || status?.loading === "update"
            }
            errorMessage={status?.errorMessage}
            error={status?.error === "create" || status?.error === "update"}
            success={
              status?.success === "create" || status?.success === "update"
            }
          />
        )
      ) : (
        <UserCommonProfile
          onSubmit={onSubmit}
          loading={status?.loading === "create" || status?.loading === "update"}
          errorMessage={status?.errorMessage}
          error={status?.error === "create" || status?.error === "update"}
          success={status?.success === "create" || status?.success === "update"}
        />
      )}
    </>
  );
}

export default DistributorProfile